import {consoleMock} from '../utils/mockUtils';
import useNavigateReplace from './useNavigateReplace';

const useManualNavigate = () => {
    // Allows you to navigate to your desired pages from the console
    const navigate = useNavigateReplace();

    consoleMock({navigate});

    return null;
};

export default useManualNavigate;
